<template lang="pug">
    crud-form( :loading='loading' :fields='fields' no-buttons )
        branch-offices-list( :items='items' no-edit slot='appendContent' )
</template>

<script>
    //
    import { CrudForm } from '@/components/reusable_components'
    import { BranchOfficesList } from '@/components/lists'
    //
    import CustomerService from '@/services/api/customer'
    import { removeRUTHyphen } from '@/services/RUTFormatter'
    //
    import CustomerDetailFields from './forms/fields/CustomerDetailFields.js'
    //
    export default {
        async beforeMount () {
            await this.reset()
        },
        components: {
            'crud-form': CrudForm,
            'branch-offices-list': BranchOfficesList,
        },
        data () {
            return {
                fields  : CustomerDetailFields,
                items   : [],
                loading : false,
            }
        },
        methods: {

            /**
             * 
             */
            async reset () {

                //
                this.loading = true

                //
                const customer = await CustomerService.findById( this.$route.params.id )

                //
                this.fields[ 0 ].value = removeRUTHyphen( customer.rut )
                this.fields[ 1 ].value = customer.alias_name
                this.fields[ 2 ].value = customer.business_name
                this.fields[ 3 ].value = customer.core_business
                
                //
                this.items = customer.branch_offices

                //
                this.fields = [ ...this.fields ]
                this.items  = [ ...this.items ]

                //
                this.loading = false
            },
        },
    }
</script>